module.exports = __webpack_public_path__ + "static/sound/crowd_start.c8f2a4f94.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/fx/crowd/crowd_start.mp3
// module id = 468
// module chunks = 1